import ApiService from '@/services/api.service'

const PostPaymentService = {
    getEraRemitList() {
        return ApiService.get(`PostPayment/eraRemitList`)
    },
    getPaymentFilteredList(params){
        return ApiService.get(`PostPayment/eraRemitFiltered?FromDateChoice=${params.FromDate}&ToDateChoice=${params.ToDate}&Downloaded=${params.Downloaded}&Posted=${params.Posted}&SortIndex=${params.SortIndex}`)
    },
    changeDownloadFlag(data){
        return ApiService.put(`PostPayment/download`, data)
    },
    postPayment(data){
        return ApiService.post(`PostPayment/postPayment`, data)
    },
    getTransNo(params){
        return ApiService.get(`PostPayment/transNo/${params}`)
    },
    getPaymentDetails(params){
        return ApiService.get(`PostPayment/details/${params}`)
    },
    getException(params){
        return ApiService.get(`PostPayment/exception?id=${params}`)
    },
    getEraClaims(params){
        return ApiService.get(`PostPayment/claimERA?PatientCode=${params.PatientCode}&DateFrom='${params.DateFrom}'`)
    },
    validateIssLineNo(params){
        return ApiService.get(`PostPayment/validateIss?IssLineNo=${params.IssLineNo}&PatientCode=${params.PatientCode}&Id=${params.Id}`)
    }
}

export default PostPaymentService;